export enum ScheduleTagsTypes {
    Regular = 0,
    SystemTagDeviceType = 1,
    SystemTagLocation = 2
}